import type { KioskFlowRepository } from '../data/kiosk-flow-repository';
import type { KioskFlow, KioskFlowOperatorContext } from '../types/kiosk-flow-types';
import { assertOperator, validateFlowName } from './flow-validation';

export class RenameKioskFlowUseCase {
  constructor(private readonly repository: KioskFlowRepository) {}

  async execute(ctx: KioskFlowOperatorContext, name: string): Promise<KioskFlow> {
    assertOperator(ctx);
    return this.repository.renameFlow(ctx, { name: validateFlowName(name) });
  }
}
